















































import Vue from 'vue';
import * as relazioneMedicaSpesaApi from '../../services/relazione-medica-spesa-api';
import {
    RelazioneMedicaSpesaListViewModel,
    RelazioneMedicaSpesa,
} from '../../types';

import relazioneMedicaSpesaEdit from '@/components/commands/RelazioneMedicaSpesaEdit.vue';

export default Vue.extend({
    components: {},
    props: {
        relazioneMedicaId: { required: true, type: Number },
        label: { required: true },
    },
    data(): RelazioneMedicaSpesaListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.importo'),
                    value: 'importo',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.note'),
                    value: 'note',
                },
            ],
            dataItems: [],
            selectedItems: [],
            dialog: false,
            editComponent: relazioneMedicaSpesaEdit,
            currentEditId: undefined,
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await relazioneMedicaSpesaApi.getByRelazioneMedica(
                this.relazioneMedicaId
            );
            this.selectedItems = [];
        },
        showDetail(item: RelazioneMedicaSpesa) {
            this.currentEditId = item.id;
            this.dialog = true;
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await relazioneMedicaSpesaApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
        getComponentProps() {
            return {
                relazioneMedicaId: this.relazioneMedicaId,
                id: this.currentEditId,
            };
        },
        dialogClose() {
            this.currentEditId = undefined;
            this.dialog = false;
        },
    },
    async mounted() {
        await this.loadData();
    },
});
